export default __webpack_public_path__ + "static/Bigger-7930b2164f76bf3153a15e4b010ce142.jpg";